App.namespace.wrap('components.stop_watch', () => {
  const measures = {
    startTime: null,
    currentTime: null,
    duration: 0,
  };

  let lapTimeStart = null;

  const getNow = () => {
    return Date.now();
  };

  const init = () => {
    measures.startTime = getNow();
  };

  const start = () => {
    lapTimeStart = getNow();
  };

  const stop = () => {
    if (!lapTimeStart) {
      return;
    }
    measures.duration += getNow() - lapTimeStart;

    lapTimeStart = null;
  };

  const addPendingDurations = () => {
    if (!lapTimeStart) {
      return;
    }
    stop();
    start();
  };

  const getTimes = () => {
    return {
      startTime: measures.startTime,
      duration: measures.duration,
      currentTime: getNow(),
    };
  };

  return {
    init,
    start,
    stop,
    getTimes,
    addPendingDurations,
  };
});
